import React, { useState } from "react";
import { styled } from "@mui/system";
import CategorySelect from "./MarketplaceComponent/CategorySelect";
import MarketplaceTemplates from "./MarketplaceComponent/MarketplaceTemplates";
import CategorySelectMobileButton from "./MarketplaceComponent/CategorySelectMobileButton";
import CategorySelectMobile from "./MarketplaceComponent/CategorySelectMobile";
import MobileWorkflowBanner from "./MobileWorkflowBanner";

const MainContainer = styled("div")({
  display: "flex",
  width: "100%",
  marginTop: "1rem",
  padding: "0px 12px",
  boxSizing: "border-box",
  "@media (max-width: 600px)": {
    padding: "0px",
  }
});

/**
 *
 * @returns The main container of the marketplace which includes category selection,
 * search and marketplace templates
 */
const MarketplaceComponent = ({
  categories,
  categoryMapping,
  allTemplates,
}) => {
  const [openMobileCategories, setOpenMobileCategories] = useState(false);
  const [categorySelected, setCategorySelected] = useState(0);

  const handleCategoryChange = (category) => {
    setCategorySelected(category);
  };

  return (
    <MainContainer>
      <CategorySelect
        categories={categories}
        currentCategory={categorySelected}
        changeCategory={handleCategoryChange}
      />
      <CategorySelectMobile
        categories={categories}
        currentCategory={categorySelected}
        changeCategory={handleCategoryChange}
        category={categorySelected}
        closeCategories={() => {
          setOpenMobileCategories(false);
        }}
        open={openMobileCategories}
      />
      <CategorySelectMobileButton
        handleOnClick={() => setOpenMobileCategories(true)}
      />
      <MarketplaceTemplates
        categorySelected={categorySelected}
        categoryMapping={categoryMapping}
        allTemplates={allTemplates}
      />
    </MainContainer>
  );
};

export default MarketplaceComponent;
